import React, { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AppButton, Box, Text } from '@common-fe/common-fe';

import routes from '@/common/routes';
import { PreventLeaveModal } from '@/modules/core/components';
import { useHistory } from '@/modules/core/hooks';

import { useInvestor } from '../../hooks';
import SelfDirectedFunds from '../SelfDirectedFunds';
import SelfDirectedWrapper from '../SelfDirectedWrapper';
import { useSelectedFundsStore } from '../stores';
interface Props {
  accountId: string;
  isEmptyPortfolioMode?: boolean;
}

const SwitchToSelfDirectedSelect: React.FC<Props> = ({ isEmptyPortfolioMode, accountId }) => {
  const { t } = useTranslation();

  const [isPreventLeave, setPreventLeave] = useState(true);

  const selectedIds = useSelectedFundsStore((state) => state.selectedFunds);
  const [isSubmitted, setSubmitted] = useState(false);
  const history = useHistory();
  const isDisabled = useMemo(() => {
    return !selectedIds.length && isSubmitted;
  }, [isSubmitted, selectedIds.length]);

  const handleNext = useCallback(() => {
    setPreventLeave(false);
    setSubmitted(true);
    if (selectedIds.length) {
      if (isEmptyPortfolioMode) {
        history.push(routes.SELF_DIRECTED_EMPTY_SWITCH_ALLOCATION(accountId));
      } else {
        history.push(routes.SELF_DIRECTED_SWITCH_ALLOCATION(accountId));
      }
    }
  }, [accountId, history, isEmptyPortfolioMode, selectedIds.length]);
  const handleBack = useCallback(() => {
    setPreventLeave(false);
    if (isEmptyPortfolioMode) {
      history.push(routes.SELF_DIRECTED_EMPTY_SWITCH_QUESTIONNAIRE(accountId));
    } else {
      history.push(routes.SELF_DIRECTED_SWITCH_QUESTIONNAIRES(accountId));
    }
  }, [accountId, history, isEmptyPortfolioMode]);
  const { data: investor } = useInvestor();
  const portfolioBalance = useMemo(() => {
    return investor.cashBalance + investor.equityValue;
  }, [investor.cashBalance, investor.equityValue]);

  const buttonText = useMemo(() => {
    return t('Next (2/3)');
  }, [t]);
  return (
    <SelfDirectedWrapper isSwitchMode isEmptyPortfolioMode={isEmptyPortfolioMode} currentStep={2}>
      <PreventLeaveModal isPrevent={isPreventLeave} />
      <Text size="3xl" data-testid="SelectFunds-switch_title" weight={700}>
        {t('Select Funds')}
      </Text>

      <SelfDirectedFunds isSwitchMode accountId={accountId} portfolioBalance={portfolioBalance} />
      <Box
        data-testid="self-directer_select"
        pad={{ top: 'l', bottom: 'l' }}
        direction="row"
        justify="end"
        align="end"
      >
        <Box direction="column" align="end">
          {isDisabled && (
            <Text margin={{ bottom: 'm' }} color="danger">
              {t('Select at least one fund')}
            </Text>
          )}

          <Box direction="row">
            <Box>
              <AppButton
                testId="self-directer_select_back"
                buttonType="secondary"
                width="140px"
                onClick={handleBack}
              >
                {t('Back')}
              </AppButton>
            </Box>
            <Box margin={{ left: 's' }}>
              <AppButton
                testId="self-directer_select_confirm"
                disabled={isDisabled}
                width="140px"
                onClick={handleNext}
              >
                {buttonText}
              </AppButton>
            </Box>
          </Box>
        </Box>
      </Box>
    </SelfDirectedWrapper>
  );
};
export default SwitchToSelfDirectedSelect;
